import { MINUTES_IN_HOUR } from '../constants/time';
import { padTwo } from '../helpers/padTwo';
// formatMinutesAsTime(570) -> "09:30"
export const formatMinutesAsTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / MINUTES_IN_HOUR);
    const minutes = totalMinutes % MINUTES_IN_HOUR;
    return `${padTwo(hours)}:${padTwo(minutes)}`;
};
